import { render, staticRenderFns } from "./urlDialog.vue?vue&type=template&id=1535c226"
import script from "./urlDialog.vue?vue&type=script&lang=js"
export * from "./urlDialog.vue?vue&type=script&lang=js"
import style0 from "./urlDialog.vue?vue&type=style&index=0&id=1535c226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports